export default "__VITE_ASSET__BI9fR_ae__"